export default __webpack_public_path__ + "static/media/bbm-penjualan.552cb610.png";